import exam from "./exam";
import evaluate from "./evaluate";

export default [ ...exam,...evaluate ];
